<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="row p-0 m-0">
    <div class="col-12">
      <i class="icon-move handle" style="margin-top:12px;float:left;"></i>
      <div class="custom-control custom-checkbox custom-control-inline" style="float: left; left:8px; margin-right: 8px !important">
        <input style="float:left;" class="custom-control-input" v-bind:id="el.Id" type="checkbox" />
        <label style="float:left; width:20px; left:3px;" class="custom-control-label" v-bind:for="el.Id"></label>
      </div>
      <input @change="onChange($event)" style="float: left;" class="form-control p-1 mr-0 pr-0 form-control-lg col-8 col-md-8" placeholder="text.." type="text" v-model="el.Text" />
      <element-controls class="element-controls" v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-controls>

    </div>
  </div>
</template>

<script>

  export default {
    name: "element-checkbox",
    components: {
      
    },
    props: {
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      el: {
        type: Object,
        default: null
      },
      overelement: {
        type: Object,
        default: null
      },
    },
    data() {
      return {

      };
    },
    methods: {
      onChange() {
        this.el.IsChanged = true;
        this.$store.markAsChanged();
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      
    },
    created() {

    },
  };

</script>

<style scoped>

  /*Make the controls a little more quite*/

  .icon-move, .item .element-controls, .item btn-icon, .item .btn-icon i {
    color: #ddd;
  }

  .item .form-control {
    border-color: transparent;
  }

  .item:focus-within .form-control, .form-control:active, .form-control:focus {
    border-color: #2196f3;
  }

  .item:focus-within .element-controls, .item:hover .element-controls,
  .item:hover .icon-move,
  .item:focus-within .icon-move,
  .item:hover .btn-icon i, .item:focus-within .btn-icon i {
    color: black;
  }

  .item:active .custom-control-label::before, .item:focus-within .custom-control-label::before, .item:hover .custom-control-label::before {
    border-color: black;
  }

  /*End Make the controls a little more quite*/



  .custom-checkbox .custom-control-label::before {
    margin-top: 9px;
  }


  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    margin-top: 9px;
  }

  label {
    display: block;
    width: 100%;
  }

  .custom-control-inline {
    display: block;
  }

  .handle {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editor-elements/element-checkbox.vue